// extracted by mini-css-extract-plugin
export default {"select":"countrySelector_select__YbPAC"};